export function isTokenExpired(token) {
  try {
    if (!token) return true;

    const parts = token.split(".");
    if (parts.length !== 3) return true;

    const payload = JSON.parse(atob(parts[1]));
    if (!payload.exp) return true;

    return payload.exp * 1000 < Date.now();
  } catch (e) {
    console.error("JWT parse hatası:", e);
    return true;
  }
}